import i18n, { translate } from '../i18nService';

export const recipesService = {
    getLocalization(localeCode, code, withCodeReplace, i18nInstance = i18n) {
        const key = `recipe.item.type.${code}`;
        if (withCodeReplace) {
            return translate(i18nInstance, key, localeCode);
        }
        const translated = translate(i18nInstance, key, localeCode);
        return translated !== key ? translated : '';
    },
    getPlaceholder(i18nInstance = i18n) {
        return i18nInstance.t('app.page.recipe.name');
    },
};
